/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Fileviewer_Try_Again_Or_Contact_SupportInputs */



/**
* | output |
* | --- |
* | "Please try again or contact support" |
*
* @param {Spaces_Fileviewer_Try_Again_Or_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_fileviewer_try_again_or_contact_support = /** @type {((inputs?: Spaces_Fileviewer_Try_Again_Or_Contact_SupportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Fileviewer_Try_Again_Or_Contact_SupportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte versuchen Sie es erneut oder wenden Sie sich an den Support")
	return /** @type {LocalizedString} */ ("Please try again or contact support")
});